/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
    StageParams,
    StageActionDetailParams,
    StageActionClearParams,
    UserStageUnclearParams,
} from 'models';
import {
    getStageService,
    postStageActionClearService,
    getStageActionDetailService,
    postUserStageUnclearService,
} from 'services';

/**
 * useStage hook
 * @returns
 */
export function useStage() {
    return {
        getStage: (payload: StageParams): Promise<void> => getStageService(payload),
        // getStageActionDetail: (payload: StageActionDetailParams): Promise<void> => getStageActionDetailService(payload),
        postStageActionClear: (payload: StageActionClearParams): Promise<void> => postStageActionClearService(payload),
        postUserStageUnclear: (payload: UserStageUnclearParams): Promise<void> => postUserStageUnclearService(payload),
    };
}
